/* eslint-disable */
import { base, baseXlsx } from '@/utils/api'

const ENDPOINT = 'attendance-module'

const getAttendanceModules = (formId, attendanceId) => {
  const config = {
    params: { formId, attendanceId }
  }
  return base.get(`/${ENDPOINT}/attendance-form-modules`, config)
}

const getAttendance = (clinicId, patientId, attendanceId, attendanceData) => {
  return base.get(
    `clinics/${clinicId}/patients/${patientId}/attendance/${attendanceId}`,
    { params: attendanceData }
  )
}

const getPusherEvent = eventId => {
  return base.get(`pusher/${eventId}/pusherEvent`)
}

const getCompletePatient = personId => {
  const config = {
    withTrashed: false
  }
  return base.get(`people/${personId}/patient`, config)
}

const unpauseAttendance = (clinicId, attendanceData) => {
  return base.post(
    'clinics/' +
      clinicId +
      '/attendance/' +
      attendanceData +
      '/unpauseAttendance'
  )
}

const getForms = (clinic_id, professional_id, type) => {
  const config = {
    params: { clinic_id, professional_id, type }
  }
  return base.get('forms', config)
}

const pauseAttendance = (clinicId, attendanceData, pauseReason) => {
  return base.post(
    `clinics/${clinicId}/attendance/${attendanceData}/pauseAttendance?reason=${pauseReason}`
  )
}

const updateAttendance = (clinicId, patientId, attendanceData) => {
  return base.put(
    'clinics/' + clinicId + '/patients/' + patientId + '/attendance',
    attendanceData
  )
}
const updateAttendanceApi = (id, attendanceData) => {
  return base.put(`/attendance/${id}`, attendanceData)
}

const updateExamAttendance = (id, data) => {
  return base.put(`examAttendances/${id}`, data)
}

const destroyMedicalRecord = data => {
  return base.delete('medicalRecords', {
    params: { ...data }
  })
}

const getMedicalRecords = (attendanceId, type = null) => {
  const config = {
    params: { attendanceId, type }
  }
  return base.get('attendanceMedicalRecords', config)
}

const cloneLastMedicalRecords = (lastAttendanceId, attendanceId) => {
  return base.post('attendanceMedicalRecords/clone', {
    lastAttendanceId,
    attendanceId
  })
}

const updateForm = (id, data) => {
  return base.put(`forms/${id}`, data)
}

const updateAttendanceForm = (id, data) => {
  return base.put('attendance-form/' + id, data)
}

const updateSurgeryInformation = (id, data) => {
  return base.put(`surgeryInformations/${id}`, data)
}

const storePatientSummary = data => {
  return base.post('patientSummaries', data)
}

const deleteSummaryItem = id => {
  return base.delete(`patientSummaries/${id}`)
}

const updatePatientSummaryStatus = data => {
  return base.patch('patientSummaries/update-status', data)
}

const getDoctors = clinicId => {
  return base.get('clinics/' + clinicId + '/doctors')
}

const getPatientHealthPlans = (clinicId, patientId) => {
  return base.get(
    `clinicHealthPlan/${clinicId}/${patientId}/patientHealthPlans`
  )
}

const getPatientAttendancesGroupedByDate = filters => {
  /* const config = {
    params: { ...filters }
  } */
  return base.post(`attendances/patient/history`, filters)
}

const getAnnotationsByDate = (clinicId, patientId, origin = null) => {
  const params = { clinicId, patientId }
  if (origin != null && origin !== '') {
    params.origin = origin
  }
  return base.get('annotations/allAnnotationsByDate', { params })
}

const createAdditionalExamModule = data => {
  return base.post(`attendances/createAdditionalExamModule`, data)
}

const getPatientLastPreConsultation = patientId => {
  return base.get(`getPatientLastPreConsultation/${patientId}`)
}

const getAttendanceDocs = attendanceId => {
  return base.get(`getAttendanceDocs/${attendanceId}`)
}

const getAllExams = patient => {
  return base.get(`attendance/all-documents/${patient}/exam`)
}

const getBackgroundOptions = type => {
  return base.get(`${type}`)
}

const getItems = (clinicId, query) => {
  const config = {
    params: { query }
  }
  return base.get(`items/${clinicId}/search`, config)
}

const getStandards = (personId, type = null) => {
  const config = {
    params: { personId, type }
  }
  return base.get(`standardRecords`, config)
}

const getAttendanceDefaultProps = (personId, patientId) => {
  const config = {
    params: { personId, patientId }
  }
  return base.get(`getAttendanceDefaultProps`, config)
}

export default {
  getAttendanceModules,
  getAttendance,
  getPusherEvent,
  unpauseAttendance,
  getForms,
  pauseAttendance,
  updateAttendance,
  updateAttendanceApi,
  updateExamAttendance,
  getMedicalRecords,
  cloneLastMedicalRecords,
  destroyMedicalRecord,
  updateForm,
  updateAttendanceForm,
  updateSurgeryInformation,
  getCompletePatient,
  storePatientSummary,
  deleteSummaryItem,
  updatePatientSummaryStatus,
  getDoctors,
  getPatientHealthPlans,
  getPatientAttendancesGroupedByDate,
  getPatientLastPreConsultation,
  getAttendanceDocs,
  getAllExams,
  getItems,
  getBackgroundOptions,
  getStandards,
  getAttendanceDefaultProps,
  createAdditionalExamModule,
  getAnnotationsByDate
}
